import React, { Fragment, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import defer from 'lodash/defer';

import { LoadingSpinner, TabContent } from 'legacy/packages/ft-cb';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';
import Header from 'chameleon/ui-stack/ui/page/header';
import HorizontalTabsContainer from 'chameleon/ui-stack/ui/page/horizontal-tabs-container';
import HorizontalTabs from 'chameleon/ui-stack/ui/base/tabs/horizontal-tabs';

import EditItem from '../EditItem/EditItem';
import { questionTypes } from './utils';

const disabledTabsClasses = [`pointer-events-none`, `opacity-50`];

const AuthorItem = (props) => {
  const title = 'Author Question';
  const subtitle = 'Question Bank';
  const { router } = props;
  const { params, goTo } = useNavigation({ router });

  /* FY-31483
   * The `Edit` component does handle initialization of new/existing question.
   * And since there isn't any other simple way of resetting it,
   * we have to mount a new component in order to clear any stale state.
   */
  const [shouldReload, setShouldReload] = useState(false);
  const reload = () => {
    setShouldReload(true);
    disableTabs();
    defer(() => {
      setShouldReload(false);
    });
  };
  // We could have use `useState` here. But we want to avoid any re-rendering
  // of this component because it means it has to go again through new question initialization.
  const tabsRef = useRef();
  const disableTabs = () =>
    tabsRef.current?.classList.add(...disabledTabsClasses);
  const enableTabs = () =>
    tabsRef.current?.classList.remove(...disabledTabsClasses);

  const authoringPageActions = { enableTabs, disableTabs, reload };

  // Reload `EditItem` component only when `qtype` changes
  // Not when mounting the component
  const didMount = useRef(false);
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    reload();
  }, [params.qtype]);

  const choiseQuestionType = (type) => () =>
    goTo(`/${params.subject}/author/question/${type}`);

  const tabs = Object.values(questionTypes).map((tab) => ({
    name: tab.label,
    isActive: params.qtype === tab.value,
    onClick: choiseQuestionType(tab.value),
    otherProps: {},
  }));

  return (
    <Fragment>
      <Header subtitle={subtitle} title={title} />
      <HorizontalTabsContainer
        leftContainer={
          <HorizontalTabs
            ref={tabsRef}
            tabsClassName={disabledTabsClasses.join(' ')}
            tabs={tabs}
            accessibility={{
              ariaLabel: 'Author Question tabs',
            }}
          />
        }
      />
      <div className="py-4" />
      {!shouldReload && (
        <EditItem
          {...props}
          isAuthoringNewPage
          authoringPageActions={authoringPageActions}
          userData={props.userData}
        />
      )}
      {shouldReload && (
        <TabContent data-test-authoring-ui>
          <div className="page_wrapper">
            <LoadingSpinner />
          </div>
        </TabContent>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({ userData: state.userData });

export default connect(mapStateToProps)(AuthorItem);
